module.exports = __webpack_public_path__ + "img/punto-sharf.83115009.svg";